import makeApiCall from "./master/axiosIndex";
// TO DO Update endpoints
export const logHoursApis = {
  createNewTimeLog: (data: FormData): Promise<any> =>
    makeApiCall({
      url: "/timelog-settings/timelog/create",
      method: "post",
      data,
      headers: { "Content-Type": "multipart/form-data" },
    }),
  listTimeLog: (data: any): Promise<any> => {
    return makeApiCall({
      url: "/timelog-settings/timelog/list",
      method: "get",
      params: data,
    });
  },
  updateTimeLogbyId: (data: any): Promise<any> =>
    makeApiCall({
      url: "/timelog-settings/timelog/update",
      method: "put",
      data,
    }),
  getShifts: (projectId: string | number): Promise<any> =>
    makeApiCall({
      url: `/calendar/calendarShifts/dropdown`,
      method: "get",
      params: { projectId },
    }),
  fetchTimelogById: (timeLogId: number): Promise<any> =>
    makeApiCall({
      url: `/timelog-settings/timelog/id/${timeLogId}`,
      method: "get",
    }),
};
